import { render, staticRenderFns } from "./positionData.vue?vue&type=template&id=0cc8613c&scoped=true&"
import script from "./positionData.vue?vue&type=script&lang=js&"
export * from "./positionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8613c",
  null
  
)

export default component.exports